// This file is auto-generated by @hey-api/openapi-ts
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { getAuthToken } from "../core/auth.gen";
import { jsonBodySerializer } from "../core/bodySerializer.gen";
import { serializeArrayParam, serializeObjectParam, serializePrimitiveParam, } from "../core/pathSerializer.gen";
import { getUrl } from "../core/utils.gen";
export var createQuerySerializer = function (_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.parameters, parameters = _b === void 0 ? {} : _b, args = __rest(_a, ["parameters"]);
    var querySerializer = function (queryParams) {
        var search = [];
        if (queryParams && typeof queryParams === "object") {
            for (var name in queryParams) {
                var value = queryParams[name];
                if (value === undefined || value === null) {
                    continue;
                }
                var options = parameters[name] || args;
                if (Array.isArray(value)) {
                    var serializedArray = serializeArrayParam(__assign({ allowReserved: options.allowReserved, explode: true, name: name, style: "form", value: value }, options.array));
                    if (serializedArray)
                        search.push(serializedArray);
                }
                else if (typeof value === "object") {
                    var serializedObject = serializeObjectParam(__assign({ allowReserved: options.allowReserved, explode: true, name: name, style: "deepObject", value: value }, options.object));
                    if (serializedObject)
                        search.push(serializedObject);
                }
                else {
                    var serializedPrimitive = serializePrimitiveParam({
                        allowReserved: options.allowReserved,
                        name: name,
                        value: value,
                    });
                    if (serializedPrimitive)
                        search.push(serializedPrimitive);
                }
            }
        }
        return search.join("&");
    };
    return querySerializer;
};
/**
 * Infers parseAs value from provided Content-Type header.
 */
export var getParseAs = function (contentType) {
    var _a;
    if (!contentType) {
        // If no Content-Type header is provided, the best we can do is return the raw response body,
        // which is effectively the same as the 'stream' option.
        return "stream";
    }
    var cleanContent = (_a = contentType.split(";")[0]) === null || _a === void 0 ? void 0 : _a.trim();
    if (!cleanContent) {
        return;
    }
    if (cleanContent.startsWith("application/json") ||
        cleanContent.endsWith("+json")) {
        return "json";
    }
    if (cleanContent === "multipart/form-data") {
        return "formData";
    }
    if (["application/", "audio/", "image/", "video/"].some(function (type) {
        return cleanContent.startsWith(type);
    })) {
        return "blob";
    }
    if (cleanContent.startsWith("text/")) {
        return "text";
    }
    return;
};
var checkForExistence = function (options, name) {
    var _a, _b;
    if (!name) {
        return false;
    }
    if (options.headers.has(name) ||
        ((_a = options.query) === null || _a === void 0 ? void 0 : _a[name]) ||
        ((_b = options.headers.get("Cookie")) === null || _b === void 0 ? void 0 : _b.includes("".concat(name, "=")))) {
        return true;
    }
    return false;
};
export var setAuthParams = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
    var security_1, security_1_1, auth, token, name, e_1_1;
    var e_1, _b;
    var _c;
    var security = _a.security, options = __rest(_a, ["security"]);
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, 6, 7]);
                security_1 = __values(security), security_1_1 = security_1.next();
                _d.label = 1;
            case 1:
                if (!!security_1_1.done) return [3 /*break*/, 4];
                auth = security_1_1.value;
                if (checkForExistence(options, auth.name)) {
                    return [3 /*break*/, 3];
                }
                return [4 /*yield*/, getAuthToken(auth, options.auth)];
            case 2:
                token = _d.sent();
                if (!token) {
                    return [3 /*break*/, 3];
                }
                name = (_c = auth.name) !== null && _c !== void 0 ? _c : "Authorization";
                switch (auth.in) {
                    case "query":
                        if (!options.query) {
                            options.query = {};
                        }
                        options.query[name] = token;
                        break;
                    case "cookie":
                        options.headers.append("Cookie", "".concat(name, "=").concat(token));
                        break;
                    case "header":
                    default:
                        options.headers.set(name, token);
                        break;
                }
                _d.label = 3;
            case 3:
                security_1_1 = security_1.next();
                return [3 /*break*/, 1];
            case 4: return [3 /*break*/, 7];
            case 5:
                e_1_1 = _d.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 7];
            case 6:
                try {
                    if (security_1_1 && !security_1_1.done && (_b = security_1.return)) _b.call(security_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 7: return [2 /*return*/];
        }
    });
}); };
export var buildUrl = function (options) {
    return getUrl({
        baseUrl: options.baseUrl,
        path: options.path,
        query: options.query,
        querySerializer: typeof options.querySerializer === "function"
            ? options.querySerializer
            : createQuerySerializer(options.querySerializer),
        url: options.url,
    });
};
export var mergeConfigs = function (a, b) {
    var _a;
    var config = __assign(__assign({}, a), b);
    if ((_a = config.baseUrl) === null || _a === void 0 ? void 0 : _a.endsWith("/")) {
        config.baseUrl = config.baseUrl.substring(0, config.baseUrl.length - 1);
    }
    config.headers = mergeHeaders(a.headers, b.headers);
    return config;
};
var headersEntries = function (headers) {
    var entries = [];
    headers.forEach(function (value, key) {
        entries.push([key, value]);
    });
    return entries;
};
export var mergeHeaders = function () {
    var e_2, _a, e_3, _b, e_4, _c;
    var headers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        headers[_i] = arguments[_i];
    }
    var mergedHeaders = new Headers();
    try {
        for (var headers_1 = __values(headers), headers_1_1 = headers_1.next(); !headers_1_1.done; headers_1_1 = headers_1.next()) {
            var header = headers_1_1.value;
            if (!header) {
                continue;
            }
            var iterator = header instanceof Headers
                ? headersEntries(header)
                : Object.entries(header);
            try {
                for (var iterator_1 = (e_3 = void 0, __values(iterator)), iterator_1_1 = iterator_1.next(); !iterator_1_1.done; iterator_1_1 = iterator_1.next()) {
                    var _d = __read(iterator_1_1.value, 2), key = _d[0], value = _d[1];
                    if (value === null) {
                        mergedHeaders.delete(key);
                    }
                    else if (Array.isArray(value)) {
                        try {
                            for (var value_1 = (e_4 = void 0, __values(value)), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
                                var v = value_1_1.value;
                                mergedHeaders.append(key, v);
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (value_1_1 && !value_1_1.done && (_c = value_1.return)) _c.call(value_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    }
                    else if (value !== undefined) {
                        // assume object headers are meant to be JSON stringified, i.e. their
                        // content value in OpenAPI specification is 'application/json'
                        mergedHeaders.set(key, typeof value === "object" ? JSON.stringify(value) : value);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (iterator_1_1 && !iterator_1_1.done && (_b = iterator_1.return)) _b.call(iterator_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (headers_1_1 && !headers_1_1.done && (_a = headers_1.return)) _a.call(headers_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return mergedHeaders;
};
var Interceptors = /** @class */ (function () {
    function Interceptors() {
        this.fns = [];
    }
    Interceptors.prototype.clear = function () {
        this.fns = [];
    };
    Interceptors.prototype.eject = function (id) {
        var index = this.getInterceptorIndex(id);
        if (this.fns[index]) {
            this.fns[index] = null;
        }
    };
    Interceptors.prototype.exists = function (id) {
        var index = this.getInterceptorIndex(id);
        return Boolean(this.fns[index]);
    };
    Interceptors.prototype.getInterceptorIndex = function (id) {
        if (typeof id === "number") {
            return this.fns[id] ? id : -1;
        }
        return this.fns.indexOf(id);
    };
    Interceptors.prototype.update = function (id, fn) {
        var index = this.getInterceptorIndex(id);
        if (this.fns[index]) {
            this.fns[index] = fn;
            return id;
        }
        return false;
    };
    Interceptors.prototype.use = function (fn) {
        this.fns.push(fn);
        return this.fns.length - 1;
    };
    return Interceptors;
}());
export var createInterceptors = function () { return ({
    error: new Interceptors(),
    request: new Interceptors(),
    response: new Interceptors(),
}); };
var defaultQuerySerializer = createQuerySerializer({
    allowReserved: false,
    array: {
        explode: true,
        style: "form",
    },
    object: {
        explode: true,
        style: "deepObject",
    },
});
var defaultHeaders = {
    "Content-Type": "application/json",
};
export var createConfig = function (override) {
    if (override === void 0) { override = {}; }
    return (__assign(__assign(__assign({}, jsonBodySerializer), { headers: defaultHeaders, parseAs: "auto", querySerializer: defaultQuerySerializer }), override));
};
